export const STREAM = 'stream';
export const GROUP = 'group';
export const ASSET = 'asset';
export const COLLECTION = 'collection';
export const USER = 'user';
export const USER_GROUP = 'user_group';
export const CONTACT = 'contact';
export const SHARE = 'share';
export const COMPANY = 'company';
export const COLLECTION_SECTION='collection_section';